import React, { Component } from "react";
import PropTypes from "prop-types";
import CircleArcs from "./CircleArcs";

class RoundDashboard extends Component {
  state = {
    NewData: [],
    w: 0,
    h: 0,
    newBenchmarkName: "",
  };
  componentDidMount() {
    const { NewData, width, height } = this.props;
    const w = width / 2;
    const h = height / 2;
    this.setState({
      NewData,
      w,
      h,
    });
  }
  componentWillReceiveProps(props) {
    this.setState({
      newBenchmarkName: props.newBenchmarkName,
      NewData: props.NewData,
    });
  }

  render() {
    const { NewData, w, h, newBenchmarkName } = this.state;
    return (
      <g transform={`translate(${w},${h})`}>
        {NewData.length > 0 ? (
          <CircleArcs
            maxR={130}
            NewData={NewData}
            newBenchmarkName={newBenchmarkName}
          />
        ) : null}
      </g>
    );
  }
}

RoundDashboard.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  NewData: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default RoundDashboard;



// WEBPACK FOOTER //
// ./src/components/d3Components/circlearc/RoundDashboard.js